<template>
  <div class="hello">
    <img class="background" src="../assets/Order/Order-background.png" />
    <img class="milk" src="../assets/Home/Milk.png" />

    <div class="Info">
      <div class="LeftSection"></div>
      <div class="rightSection">
        <h1>
          Hello, I am your <br />
          organic milk.
        </h1>
        <div class="details">
          <HelloDetails
            class="helloDetails"
            v-for="detail in details"
            :key="detail.id"
            :helloImage="detail.helloImage"
            :helloDescription="detail.helloDescription"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelloDetails from "./layouts/HelloDetails";
export default {
  components: {
    HelloDetails,
  },
  data() {
    return {
      details: [
        {
          helloImage: require("../assets/Home/HelloSection/cow.png"),
          helloDescription: "I come from organic cows around you.",
        },
        {
          helloImage: require("../assets/Home/HelloSection/bottles.png"),
          helloDescription: "I come to your doorstep free of charge.",
        },
        {
          helloImage: require("../assets/Home/HelloSection/no_preservatives.png"),
          helloDescription: "I have no chemicals or preservatives.",
        },
        {
          helloImage: require("../assets/Home/HelloSection/flavour.png"),
          helloDescription: "I am rich in flavour and creamy in texture.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.hello {
  position: relative;
  /* background-image: url("../assets/Order/Order-background.png"); */
  height: inherit;
  color: #fff;
  height: 1169.08px;
  /* contain: content; */
}
.Info {
  display: flex;
}
img.background {
  /* width: 100%; */
  height: 100%;
  position: absolute;
  top: 0;
  /* z-index: -1; */
}
h1 {
  color: #fff;
  font-family: "DM Sans";
  font-size: 36px;
  font-weight: 700;
  line-height: 47px;
}
.details {
  max-width: 500px;
  margin-top: 50px;
  /* background-color: green; */
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  /* place-items: center; */
}
.helloDetails {
  flex: 200px;
  z-index: 2;
}
img.milk {
  /* width: 100%; */
  width: 540px;
  position: absolute;
  top: -90px;
  left: -100px;
  /* z-index: -1; */
}
.LeftSection,
.rightSection {
  width: 100%;
}
@media screen and (max-width:720px){
  img.background {
  /* width: inherit; */
  display: none;
}
.hello{
  background-color: #0077B6;
}

img.milk {
  width: 540px;
  position: absolute;
  top: -90px;
  left: -400px;
  /* z-index: 1; */
}
h1 {
  font-size: 26px;
  font-weight: 700;
  line-height: 27px;
}
.hello {
  height: inherit;
  /* contain: content; */
  padding-bottom: 150px;
}
}
</style>